export class InsertPlanimetriaOUTModel {
    downloadURL: string
    ref: string
    statusURL: string
}
